import Config from './config'
import Phaser from 'phaser'
import Planet from '../planet/planet'
import Star from '../star/star'
import tinycolor from 'tinycolor2'

const devEntities = () => new Promise((resolve, reject) => {
    Config.gameStats.resources = 1000
    // Config.difficultyLevels.difficulty2.planetMineResourceDelay = 4000

    const camera = Config.scene.cameras.main
    camera.setViewport(0, 0, window.screen.width * 3, window.screen.height * 3)

    camera.setZoom(2)
    camera.centerOn(200, 200)

    const createColorsFromClimate = (climate, range, x, y) => {
        let swatchRow1X = 20
        let swatchRow1Y = y + 12

        Config.scene.add.text(swatchRow1X, y, climate, {
            fontFamily: 'Roboto, sans-serif',
            fontSize: '10px',
            color: '#fff',
        })

        for (let i = range[0]; i < range[1]; i += 1) {
            const color = tinycolor('hsl(' + i + ', 60%, 50%)')
                .brighten(10)
                .toHex()
            const g = Config.scene.add.graphics({
                fillStyle: {color: `0x${color}`},
            })
            const s = new Phaser.Geom.Rectangle(swatchRow1X, swatchRow1Y, 3, 4)
            g.fillRectShape(s)
            g.setInteractive()

            // Config.scene.add.text(swatchRow1X, swatchRow1Y, i, {
            //     fontFamily: 'Roboto, sans-serif',
            //     fontSize: '4px',
            //     color: `#${color}`,
            // })

            swatchRow1X += 3
        }
    }

    // Climates
    // HSL range 0 - 360
    // createColorsFromClimate('cold', [150, 240], 20, 30)
    // createColorsFromClimate('gas', [200, 360], 20, 50)
    // createColorsFromClimate('hot', [0, 40], 20, 70)
    // createColorsFromClimate('ice', [180, 200], 20, 90)
    // createColorsFromClimate('moderate', [90, 150], 20, 110)
    // createColorsFromClimate('warm', [40, 60], 20, 130)
    createColorsFromClimate('cold', [150, 240], 20, 30)
    createColorsFromClimate('gas', [0, 330], 20, 50)
    createColorsFromClimate('hot', [0, 40], 20, 70)
    createColorsFromClimate('ice', [210, 250], 20, 90)
    createColorsFromClimate('moderate', [90, 150], 20, 110)
    createColorsFromClimate('warm', [40, 60], 20, 130)

    // Test entity display
    const entities = {}
    const entitiesStartY = 80
    let x = 90
    let y = entitiesStartY
    const diameter = 20
    const rowCount = 6

    const showPlanetDetails = (planet) => {
        Config.scene.add.text(x - 60, y - diameter, planet.climate, {
            fontFamily: 'Roboto, sans-serif',
            fontSize: '10px',
            color: '#fff',
        })

        const createSwatch = (x, y, color) => {
            const g = Config.scene.add.graphics({
                fillStyle: {color},
            })
            const r = new Phaser.Geom.Rectangle(x, y, 10, 10)
            g.fillRectShape(r)
        }

        createSwatch(x - 60, y - diameter + 14, planet.fillColorLight)
        createSwatch(x - 60, y - diameter + 24, planet.fillColor)
        createSwatch(x - 60, y - diameter + 34, planet.fillColorDark)
    }

    // Col 1
    for (let i = 0; i < rowCount; i += 1) {
        y += 110

        const key = `planet1${i}`

        entities[key] = new Planet({
            faction: Config.userFactionName,
            // diameter,
            discovered: true,
            x,
            y,
        })
        showPlanetDetails(entities[key])
    }

    // Col 2
    y = entitiesStartY
    for (let i = 0; i < rowCount; i += 1) {
        x = 210
        y += 110

        const key = `planet2${i}`

        entities[key] = new Planet({
            faction: Config.userFactionName,
            // diameter,
            discovered: true,
            x,
            y,
        })
        showPlanetDetails(entities[key])
    }

    // Col 3
    y = entitiesStartY
    for (let i = 0; i < rowCount; i += 1) {
        x = 310
        y += 110

        entities[`star${i}`] = new Star({
            discovered: true,
            x,
            y,
        })
    }

    // console.log('entities', entities)

    // setTimeout(() => {
    //     entities.planet21.destroy()
    //     entities.star0.destroy()
    // }, 5000)

    return resolve()
})

export default devEntities
